import $ from 'jQuery';

let mainEl = $(".signpost");

$(function () {
    if (mainEl.length > 0) {
        bindContinueButtons(mainEl);
        bindCheckboxes(mainEl);
        bindRadiobutton(mainEl);
    }
});

const bindContinueButtons = (element) => {
    for (let i = 2; i <= 5; i++) {
        element.off('click', `#step-${i}`);
        element.on('click', `#step-${i}`, function () {
            let clickable = true;

            if (i == 3) {
                if(!$(".signpost__checkbox").is(":checked")) {
                    clickable = false;
                    $('#step-3-error').show();
                } else {
                    $('#step-3-error').hide();
                }
            }

            if (i == 4) {
                if (!$("input[name='ekonomicky_aktivni']:checked").val() && !$("input[name='duchod']:checked").val()) {
                    clickable = false;
                    $('#step-4-error').show();
                } else {
                    $('#step-4-error').hide();
                }
            }

            let kompletniZatepleni = $("#checkbox_zatepleni_kompletni").is(":checked");
            let dilciZatepleni = $("#checkbox_zatepleni_castecne").is(":checked");
            let vymenaOken = $("#checkbox_okna_dvere").is(":checked");
            let novostavba = $("#checkbox_novostavba").is(":checked");
            let vymenaZdrojeTepla = $("#checkbox_zdroj_tepla").is(":checked");
            let fotovoltaika = $("#checkbox_fotovoltaika").is(":checked");
            let ohrevVody = $("#checkbox_ohrev_vody").is(":checked");
            let zelenaStrecha = $("#checkbox_zelena_strecha").is(":checked");
            let destovaVoda = $("#checkbox_destova_voda").is(":checked");
            let dobijeciStanice = $("#checkbox_dobijece_stanice").is(":checked");
            let odpadniVoda = $("#checkbox_odpadni_voda").is(":checked");
            let rizeneVetrani = $("#checkbox_rizene_vetrani").is(":checked");
            
            let duchodAno = $("#duchod_ano").is(":checked");

            if (clickable) {
                if (i == 3 && (zelenaStrecha || destovaVoda || dobijeciStanice)
                    && !(kompletniZatepleni || dilciZatepleni || novostavba || vymenaZdrojeTepla || vymenaOken || fotovoltaika || ohrevVody || odpadniVoda || rizeneVetrani)) {

                    element.find(`#signpost-4`).addClass('active');
                    element.find(`.signpost__kombinace`).css('display', 'flex');
                    element.find('.signpost__disclaimer').css('display', 'block');

                } else if (i == 3 && !(kompletniZatepleni
                    || ((dilciZatepleni || vymenaOken || ohrevVody || fotovoltaika) 
                        && !(kompletniZatepleni || novostavba || vymenaZdrojeTepla || zelenaStrecha || destovaVoda || dobijeciStanice || odpadniVoda || rizeneVetrani))
                    || (vymenaZdrojeTepla && $(".signpost__checkbox:checked").length == 1)
                    || (vymenaZdrojeTepla && (dilciZatepleni || vymenaOken || ohrevVody || fotovoltaika)))) {

                        element.find(`#signpost-4`).addClass('active');
                        element.find(`.signpost__default`).css('display', 'flex');
                        element.find('.signpost__disclaimer').css('display', 'block');

                } else {
                    element.find(`#signpost-${i}`).addClass('active');
                }

                if (i != 5) {
                    $(this).parent().hide();
                }

                if (i == 3) {
                    if(kompletniZatepleni) {
                        element.find(`#signpost-3-1`).addClass('active');
                    } else {
                        element.find(`#signpost-3-2`).addClass('active');
                    }
                }

                if (i == 4) {
                    let result = false;

                    if(kompletniZatepleni) {
                        if($("#ekonomicky_aktivni_ano").is(":checked")) {
                            element.find(`.signpost__oprav`).css('display', 'flex');
                            result = true;
                        }
                    }

                    if ((dilciZatepleni || vymenaOken || ohrevVody || fotovoltaika) 
                        && !(kompletniZatepleni || novostavba || vymenaZdrojeTepla || zelenaStrecha || destovaVoda || dobijeciStanice || odpadniVoda || rizeneVetrani)) {
                        if(duchodAno) {
                            element.find(`.signpost__dilci`).css('display', 'flex');
                            result = true;
                        }
                    }

                    if (vymenaZdrojeTepla && $(".signpost__checkbox:checked").length == 1) {
                        if(duchodAno) {
                            element.find(`.signpost__kotlik`).css('display', 'flex');
                            result = true;
                        }
                    }

                    if (vymenaZdrojeTepla && (dilciZatepleni || vymenaOken || ohrevVody || fotovoltaika)) {
                        if(duchodAno) {
                            element.find(`.signpost__energie`).css('display', 'flex');
                            element.find('.signpost__results').addClass('signpost__resultsLong');
                            result = true;
                        }
                    }

                    if (!result) {
                        element.find(`.signpost__default`).css('display', 'flex');
                    }

                    element.find('.signpost__disclaimer').css('display', 'block');
                }

                if (i == 5) {
                    element.find(`.signpost__result`).css('display', 'none');
                    element.find(`.signpost__disclaimer`).css('display', 'none');
                }
            }
        });
    }
}

const bindCheckboxes = (element) => {
    element.off('click', '.signpost__checkbox');
    element.on('click', '.signpost__checkbox', function () {
        let $this = $(this);

        if ($this.is(':checked')) {
            $this.parent().find('.checkbox__label').addClass('signpost__label-green');
        } else {
            $this.parent().find('.checkbox__label').removeClass('signpost__label-green');
        }

        if(!$(".signpost__checkbox").is(":checked")) {
            $('#step-3').removeClass('smoothscroll')
        } else {
            $('#step-3').addClass('smoothscroll')
        }

        let id = $this.attr('id');

        if (id == 'checkbox_zatepleni_kompletni') {
            if ($("#checkbox_zatepleni_kompletni").is(":checked")){
                element.find('#checkbox_zatepleni_castecne').attr('disabled', true);
                element.find('#checkbox_novostavba').attr('disabled', true);
            } else {
                element.find('#checkbox_zatepleni_castecne').removeAttr('disabled');
                element.find('#checkbox_novostavba').removeAttr('disabled');
            }
        }

        if (id == 'checkbox_zatepleni_castecne') {
            if ($("#checkbox_zatepleni_castecne").is(":checked")){
                element.find('#checkbox_zatepleni_kompletni').attr('disabled', true);
                element.find('#checkbox_novostavba').attr('disabled', true);
            } else {
                element.find('#checkbox_zatepleni_kompletni').removeAttr('disabled');
                element.find('#checkbox_novostavba').removeAttr('disabled');
            }
        }

        if (id == 'checkbox_novostavba') {
            if ($("#checkbox_novostavba").is(":checked")){
                element.find('#checkbox_zatepleni_kompletni').attr('disabled', true);
                element.find('#checkbox_zatepleni_castecne').attr('disabled', true);
            } else {
                element.find('#checkbox_zatepleni_kompletni').removeAttr('disabled');
                element.find('#checkbox_zatepleni_castecne').removeAttr('disabled');
            }
        }

        element.find('.signpost__results').removeClass('signpost__resultsLong');
        element.find(`.signpost__result`).css('display', 'none');
        element.find(`.signpost__disclaimer`).css('display', 'none');

        element.find('.signpost__radio').prop('checked', false);

        element.find(`#signpost-3`).removeClass('active');
        element.find(`#signpost-3-1`).removeClass('active');
        element.find(`#signpost-3-2`).removeClass('active');

        element.find('#step-3').parent().show();
        element.find('#step-4').parent().show();
    });
}

const bindRadiobutton = (element) => {
    element.off('click', '.signpost__radio');
    element.on('click', '.signpost__radio', function () {
        element.find('.signpost__radio').prop('checked', false);
        $(this).prop('checked', true);

        element.find('.signpost__results').removeClass('signpost__resultsLong');
        element.find(`.signpost__result`).css('display', 'none');

        element.find('#step-4').parent().show();

        if(!$(".signpost__radio").is(":checked")) {
            $('#step-4').removeClass('smoothscroll')
        } else {
            $('#step-4').addClass('smoothscroll')
        }
    });
}